import PropTypes from "prop-types";
import classNames from "classnames";
import { useAddBookmarkModal } from "@/react/components/Modals/AddBookmarkModal";
import { DeleteBookmarkConfirmation } from "@/react/components/Spaces/Bookmarks/DeleteBookmarkConfirmation";
import { useBoolean } from "@/react/hooks/utils/useBoolean";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { BookmarkTippyContent } from "../BookmarkTippyContent";
import { useSortableBookmarkContext } from "../context/SortableBookmark";
import { LinkBookmarkView } from "./LinkBookmarkView";

export const LinkBookmark = ({
  bookmark,
  tippyPlacement = "top",
  isInsideFolder = false,
}) => {
  const { space } = useSortableBookmarkContext();
  const bookmarkModal = useAddBookmarkModal();
  const [shouldShowDeleteConfirmation, toggleDeleteConfirmation] =
    useBoolean(false);

  return (
    <>
      <TippyV2
        interactive={false}
        content={<BookmarkTippyContent bookmark={bookmark} />}
        flip="false"
        boundary="window"
        arrow
        size="medium"
        animation="fade"
        placement={tippyPlacement}
        touch={false}
      >
        <LinkBookmarkView
          space={space}
          bookmark={bookmark}
          isInsideFolder={isInsideFolder}
          onEditClick={() => {
            bookmarkModal.show({
              space: space,
              isEdit: true,
              bookmark,
              isFolder: false,
            });
          }}
          onDeleteClick={() => {
            toggleDeleteConfirmation();
          }}
          className={classNames({
            "!p-0": isInsideFolder,
          })}
        />
      </TippyV2>
      <DeleteBookmarkConfirmation
        space={space}
        bookmark={bookmark}
        isOpen={shouldShowDeleteConfirmation}
        onClose={toggleDeleteConfirmation}
      />
    </>
  );
};

LinkBookmark.propTypes = {
  bookmark: PropTypes.object.isRequired,
  tippyPlacement: PropTypes.string,
  isInsideFolder: PropTypes.bool,
  className: PropTypes.string,
};
